import { api } from '../api';

export type JobStatusType = {
  completedAt: string | null;
  createdAt: string;
  failedAt: string | null;
  id: string;
  updatedAt: string;
};

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getJobStatus: build.query<JobStatusType, string>({
      query: (jobId) => `job_statuses/${jobId}.json`,
    }),
  }),
});

export const { useGetJobStatusQuery } = extendedApi;
